import { render, staticRenderFns } from "./ReturnSuccesfull.vue?vue&type=template&id=520fc352&"
import script from "./ReturnSuccesfull.vue?vue&type=script&lang=js&"
export * from "./ReturnSuccesfull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports